export default function registerGlobalComponents(app) {
    const requireComponent = require.context(
        './components', // The folder containing components
        false,          // Whether to look in subfolders
        /\.vue$/        // The regex pattern to match .vue files
      );
    
    requireComponent.keys().forEach((fileName) => {
        // Get the component config
        const componentConfig = requireComponent(fileName);
        // Extract the component name
        const componentName = fileName
            .split('/')
            .pop()
            .replace('.vue', '');
        // Globally register the component
        app.component(componentName, componentConfig.default || componentConfig);
    });
}